import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../config/constants';
import usePersonStore from '../../store/personStore';
import { getCarFn } from '../../transactions/cars/car';
import { useNavigate } from 'react-router-dom';

const { CARS } = QUERY_KEYS;

const useCarList = () => {
  const { setCarList } = usePersonStore();

  return useQuery({
    queryKey: [CARS],
    queryFn: () => getCarFn(),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setCarList(data);
    },
  });
};

export const useGetCarList = (
  searchTerm = '',
  pageParam = 1,
  length = 6,
  enableCar = false
) => {
  const { setShowRetailDashBoardType, setFetchCars } = usePersonStore();

  const navigate = useNavigate();

  return useQuery({
    queryKey: [CARS],
    queryFn: () => getCarFn(searchTerm, pageParam, length),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!enableCar,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setFetchCars(false);

      if (data && data.data.length <= 5) {
        setShowRetailDashBoardType(true);
      } else {
        setShowRetailDashBoardType(false);
      }
      navigate('/dashboard');
    },
  });
};

export const useGetCars = (searchTerm = '',selectedDriver) => {
  return useInfiniteQuery({
    queryKey: [CARS, searchTerm, selectedDriver],
    queryFn: ({ pageParam = 1 }) => getCarFn(searchTerm, pageParam,25,selectedDriver),
    getNextPageParam: (lastPage, pages) => {
      return pages.length + 1;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

export default useCarList;
